import { render, staticRenderFns } from "./allnote.vue?vue&type=template&id=5c4466e8&"
import script from "./allnote.vue?vue&type=script&lang=js&"
export * from "./allnote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports